import {
  useAppLocation,
  useAppNavigate,
  useAppSearch,
} from "_graphql/cache/auth";
import {
  ActionButton,
  CalendarHeader,
  OfficeButton,
  Paginator,
  RegularInsurerPicker,
  TableComponent,
} from "components";
import { Action } from "components/buttons/action-button";
import { usePagination } from "hooks";
import { FC } from "react";
import CreateTreatyClaimContainer from "./create";
import { useTreatyClaimPayments } from "hooks/data/use-treaties";
import numeral from "numeral";
import RemoveContainer from "./remove";

type Props = {};

const TreatyClaimPaymentsPage: FC<Props> = () => {
  const navigate = useAppNavigate();
  const searchParams = useAppSearch();
  const { params } = useAppLocation();
  const { offset, limit, setPage } = usePagination();
  const { payments, length, loading, refetch } = useTreatyClaimPayments({
    participantId: params?.share || "",
    treatyClaimId: params.claim || "",
  });

  const dispatchAction =
    (id: string, action: Exclude<Action, "expand" | "goto" | "clone">) =>
      () => {
        navigate({
          search: (old) => ({
            ...old,
            id,
            modal: action,
          }),
        });
      };

  return (
    <>
      <main className="flex-1 flex flex-col overflow-hidden bg-background-500">
        <CalendarHeader
          renderActions={() => (
            <OfficeButton size="sm" onClick={dispatchAction("", "create")}>
              <span className="text-gray-200">Create Payment</span>
            </OfficeButton>
          )}
        />
        <div className="flex flex-1 overflow-y-auto">
          <div className="flex-1 mx-auto min-w-0  py-4 sm:py-6 overflow-hidden overflow-y-auto light flex">
            <TableComponent
              loading={loading}
              title={"treaty claims payments"}
              hasSearch
              columns={[
                {
                  name: "Payment Type",
                  accessor: "treaty_reference",
                  render: (value) => {
                    const details = JSON.parse(value?.payment_detail || "{}");
                    return (
                      <div className="flex flex-row leading-0">
                        <span className="font-medium text-gray-200">
                          {details?.payment_type || "N/A"}{" "}
                        </span>
                      </div>
                    );
                  },
                },
                {
                  name: "Bank Name",
                  accessor: "insurer.insurer_company_name",
                  render: (value) => {
                    const details = JSON.parse(value?.payment_detail || "{}");
                    return (
                      <div className="flex flex-row leading-0">
                        <span className="font-medium text-gray-200">
                          {details?.payment_from?.bank_name || "N/A"}{" "}
                        </span>
                      </div>
                    );
                  },
                },
                {
                  name: "Beneficiary Bank Name",
                  accessor: "employee.employee_first_name",
                  render: (value) => {
                    const details = JSON.parse(value?.payment_detail || "{}");
                    return (
                      <div className="flex flex-row leading-0">
                        <span className="font-medium text-gray-200">
                          {details?.payment_to || "N/A"}{" "}
                        </span>
                      </div>
                    );
                  },
                },
                {
                  name: "Payment Amt",
                  accessor: "treaty_deduction",
                  render: (value) => (
                    <div className="flex leading-0">
                      <span>
                        {numeral(value?.payment_amount).format("0,0")}
                      </span>
                    </div>
                  ),
                },
                {
                  name: "Payment Date",
                  accessor: "created_at",
                },
                {
                  name: "Actions",
                  accessor: "actions",
                  render: (value) => (
                    <>
                      {/* <ActionButton
                        action={"view"}
                        tooltip="View Payment"
                        onClick={dispatchAction(
                          value?.payment_uuid || "",
                          "create"
                        )}
                      />
                      <ActionButton
                        action={"update"}
                        tooltip="Update Payment"
                        onClick={dispatchAction(
                          value?.payment_uuid || "",
                          "update"
                        )}
                      /> */}
                      <ActionButton
                        action={"remove"}
                        tooltip="Remove Payment"
                        onClick={dispatchAction(
                          value?.payment_id || "",
                          "remove"
                        )}
                      />
                    </>
                  ),
                },
              ]}
              data={payments}
              refetch={refetch}
              renderActions={() => (
                <>
                  <RegularInsurerPicker
                    id={"insurer"}
                    label={""}
                    rawId
                    values={{ insurer: searchParams?.insurer }}
                    setFieldValue={() => { }}
                    setFieldTouched={() => { }}
                    setFieldError={() => { }}
                  />
                </>
              )}
              pagination={() => (
                <Paginator
                  offset={offset}
                  limit={limit}
                  totalItems={length}
                  currentSize={payments.length}
                  setOffset={setPage}
                />
              )}
            />
          </div>
        </div>

        {searchParams?.modal === "create" && (
          <CreateTreatyClaimContainer
            open={searchParams?.modal === "create"}
            setOpen={(val) =>
              navigate({
                search(prev) {
                  return {
                    ...prev,
                    modal: val ? "create" : undefined,
                  };
                },
              })
            }
          />
        )}
        {searchParams?.id && searchParams?.modal === "remove" && (
          <RemoveContainer
            open={searchParams?.modal === "remove"}
            setOpen={(val) =>
              navigate({
                search(prev) {
                  return {
                    ...prev,
                    modal: val ? "remove" : undefined,
                    id: val ? searchParams?.id : undefined,
                  };
                },
              })
            }
          />
        )}
      </main>
    </>
  );
};

export default TreatyClaimPaymentsPage;
